import { render, staticRenderFns } from "./topProduct.vue?vue&type=template&id=1e8276cf"
import script from "./topProduct.vue?vue&type=script&lang=js"
export * from "./topProduct.vue?vue&type=script&lang=js"
import style0 from "./topProduct.vue?vue&type=style&index=0&id=1e8276cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports